import script from "./MailingListSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./MailingListSignup.vue?vue&type=script&setup=true&lang=js"

import "./MailingListSignup.vue?vue&type=style&index=0&id=12a18c46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a18c46"]])

export default __exports__